
import { Vue } from 'vue-class-component'
import { ACTION_SCENARIO_TEMPLATE } from '@/store/actions'
import { IScenarioTemplate } from '@/utils/types'
import { constant } from '@/utils/constants'

export default class ScenarioMixin extends Vue {
  get selectedAppId() {
    return this.$route.params.app_id as string
  }

  get selectedScenarioTemplateId() {
    return this.$route.params.scenario_template_id || ''
  }

  get actionType() {
    return this.$route.params.action_type || ''
  }

  // Delete Scenario
  async onDelete(scenario_template: IScenarioTemplate) {
    this.$q
      .dialog({
        title: this.$t('confirm'),
        message: this.$t('are_you_sure_you_want_to_delete'),
        cancel: true,
        persistent: true,
      })
      .onOk(async () => {
        const success = await this.$store.dispatch(ACTION_SCENARIO_TEMPLATE.DELETE, scenario_template._id)
        if (success) {
          this.$q.notify({
            message: this.$t('messages.deleted'),
            color: 'positive',
          })
        }
      })
  }

  goto(name: string, params = {}) {
    this.$router.push({
      name,
      params,
    })
  }

  detailPath(name: string, params = {}) {
    return {
      name: name,
      params: params,
    }
  }

  onCopy(data: IScenarioTemplate) {
    this.goto('scenario_template_setting', {
      app_id: this.selectedAppId,
      scenario_template_id: data._id,
      action_type: constant.ACTION_TYPE.COPY,
    })
  }
}
